import React, { useState } from "react";
import Slider from "react-slick";
import { Match } from "./InfoContext";
import MatchDay from "./MatchDay";
import classNames from "classnames";

type MatchDaysCarouselProps = {
  groupedByWeek: Record<number, Match[]>;
};

const MatchDaysCarousel: React.FC<MatchDaysCarouselProps> = ({
  groupedByWeek,
}) => {
  const [selectedWeek, setSelectedWeek] = useState(0);
  let sliderRef = React.useRef<Slider | null>(null);
  const sortedWeeks = Object.keys(groupedByWeek)
    .map(Number)
    .sort((a, b) => a - b)
    .map((week) => week - 1);

  const settings = {
    className: "center ",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 1,
    speed: 500,
    afterChange: (current: number) => setSelectedWeek(current),
  };
  return (
    <div className="flex flex-col max-w-6xl mx-auto">
      <div className="mb-10">
        <div className={classNames("px-10 lg:px-20")}>
          <Slider
            ref={(slider) => {
              sliderRef.current = slider;
            }}
            {...settings}
          >
            {sortedWeeks.map((week, index) => (
              <div
                key={index}
                className={classNames(
                  " text-center w-full rounded bg-white/10 p-2 cursor-pointer mx-auto",
                  {
                    "bg-white/20": selectedWeek === week,
                    "text-gray-400": selectedWeek !== week,
                    "text-white": selectedWeek === week,
                  }
                )}
                onClick={() => {
                  setSelectedWeek(week);
                  sliderRef.current?.slickGoTo(week);
                }}
              >
                <h3>week {week + 1}</h3>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <MatchDay
        week={selectedWeek + 1}
        matches={groupedByWeek[selectedWeek + 1]}
      />
    </div>
  );
};

export default MatchDaysCarousel;
